<template>
  <div class="messages-block">
    <div class="header flex-row">
      <button @click="$emit('closePanel', {});" class="btn btn-transparent"><i class="fal fa-chevron-left"></i></button>

      <span class="flex-expand block-vcenter padding-half-h smaller">
        {{ theme.name }}
      </span>
      
      <tippy :interactive="true" placement="bottom-end" trigger="click" :maxWidth="500" theme="light sodnp" ref="themeTeamTippy" :onShow="onShowThemeTeam">
        <template v-slot:trigger>
          <button class="btn btn-transparent"><i class="fad fa-users"></i></button>
        </template>

        <div class="team-users">
          <user-entry :id="uid" v-for="uid in themeUserIds" :key="'themeTeam' + uid" />
          <a class="btn full-width margin-t" href="javascript:" v-if="isUsersEditVisible" @click="onShowThemeTeam(); $modal.show('PopupEditTaskTheme', {task: task, theme: theme})">
            <i class="fal fa-pencil"></i> Изменить участников
          </a>
        </div>
      </tippy>


      <button class="btn btn-transparent" @click="$modal.show('PopupEditTaskTheme', {task: task, theme: theme})"><i class="fal fa-cog"></i></button>
    </div>
    <div class="messages" :class="{customer: isCustomerInTheme}" ref="msgList">
      <vue-element-loading :active="isLoading"/>
      <template v-for="(m, index) in messages">
        <chat-message
          :key="m.id + m.updatedAt"
          :message="m"
          :showDate="index == 0 || createdAtDate(m.createdAt) != createdAtDate(messages[index-1].createdAt)"
          :showAvatar="index == 0 || m.profileId != messages[index-1].profileId"
          @editMessage="onStartEditMessage"
        />
      </template>
    </div>
    <div class="typing" v-if="typingNames">{{ typingNames }}</div>
    <div class="compose no-padding">
      <!-- отправляемые файлы -->
      <div class="files padding-h" v-show="composing.files.length">
        <file-entry :file="file.response.id ? file.response : file" v-for="(file, index) in composing.files" :key="file.id">
          <template slot="right" v-if="!file.success">
            <div class="progressbar">
              <div class="bar" v-bind:style="{'width': + file.progress + '%'}"></div>
            </div>
          </template>
          <template slot="right" v-else>
            <button class="btn" @click="composing.files.splice(index, 1)">
              <i class="fal fa-times"></i>
            </button>
          </template>
        </file-entry>
      </div>
    </div>
    <div class="compose flex-row">
      <!-- поле ввода с кнопками -->
      <file-upload
        class="btn"
        name="file"
        :post-action="uploadUrl"
        :multiple="true"
        :maximum="5"
        :drop="true"
        :thread="3"
        :headers="authHeaders"
        input-id="theme_chat_upload"
        v-model="composing.files"
        ref="upload"
        v-if="!composing.message_id"
        @input-filter="inputFile">
        <i class="fal fa-paperclip"></i>
      </file-upload>

      
      <button class="btn text-red" @click="cancelMessageEdit" v-if="composing.message_id" title="Отменить редактирование">
        <i class="fas fa-times" ></i>
      </button>
      <textarea-autosize
        :min-height="30"
        :max-height="150"
        v-model="composing.text"
        ref="textInput" 
        @keydown.native.enter="handleEnter"
        @keydown.native="handleKeyup"
        @paste.native="onPaste"/>

      <button class="btn text-green" @click="sendMessage()">
        <i class="fad fa-pencil" v-if="composing.message_id"></i>
        <i class="fad fa-paper-plane" v-else></i>
      </button>
    </div>
  </div>
</template>

<script>
import { NOTIFICATIONS_REQUEST } from "@/store/actions/notifications"
import { mapGetters } from "vuex";

import VueElementLoading from 'vue-element-loading'
import FileUpload from 'vue-upload-component'
import FileEntry from '@/components/FileEntry.vue';
import UserEntry from '@/components/UserEntry.vue';
import ChatMessage from '@/components/chat/ChatMessage.vue';

import { apiCall, apiAuthHeaders, API_PREFIX } from "@/utils/api"

export default {
  name: 'TaskThemeChat',
  components: {
    VueElementLoading,
    FileEntry,
    FileUpload,
    UserEntry,
    ChatMessage
  },
  props: ['task', 'theme'],
  data() {
    return {
      isLoading: false,
      isSending: false,
      isUploading: false,
      messages: [],
      typing: [],
      typingHandlers: {},
      meTyping: false,
      meTypingHandler: null,
      composing: {
        message_id: null,
        text: "",
        files: [],
        taskId: this.task.id,
        themeId: this.theme.id,
      }
    }
  },
  computed: {
		...mapGetters(["authId", "allUsersKeyed"]),
    authHeaders() { return apiAuthHeaders() },
    uploadUrl() {
      return API_PREFIX + 'themes/upload/' + this.theme.id
    },
    typingNames() {
      var names = this.typing.filter(t => t != this.authId).map(t => this.allUsersKeyed[t].fullName())
      if (names.length == 0) {
        return ''
      }
      if (names.length == 1) {
        return names[0] + ' набирает сообщение'
      }
      return names.splice(0, names.length-1).join(', ') + ' и ' + names[0] + 'набирают сообщение'
    },
    themeUserIds() {
      let ids = []
      for (var i=0; i<this.theme.users.length; i++) {
        ids.push(this.theme.users[i].profileId)
      }
      return ids
    },
    isCustomerInTheme() {
      return this.theme.userIds.some(uid => this.allUsersKeyed[uid].isCustomer)
    },
    isUsersEditVisible() {
      // for all-free to join themes it's not needed
      return this.theme.type > 0
    }
	},
  mounted() {
    this.$sodnpHub.$on('task-theme-msg-received', this.onMessageReceived)
    this.$sodnpHub.$on('task-theme-msg-updated', this.onMessageUpdated)
    this.$sodnpHub.$on('task-theme-msg-typing', this.onMessageTypingAdded)

    this.loadMessages()
  },
  beforeDestroy: function() {
    this.$sodnpHub.$off('task-theme-msg-received', this.onMessageReceived)
    this.$sodnpHub.$off('task-theme-msg-updated', this.onMessageUpdated)
    this.$sodnpHub.$off('task-theme-msg-typing', this.onMessageTypingAdded)
  },
  methods: {
    createdAtBeauty(datetime) {
      return this.$moment.utc(datetime).local().calendar()
    },
    createdAtTime(datetime) {
      return this.$moment.utc(datetime).local().format('HH:mm');
    },
    createdAtDate(datetime) {
      // return this.$moment.utc(datetime).local().calendar()
      // return this.$moment.utc(datetime).local().format('DD.MM.YYYY');
      return this.$moment.utc(datetime).local().format('LL')
    },
    onShowThemeTeam() {
        document.body.click(); // скрываем все открытые tippy
        return true
    },
    loadMessages() {
      this.isLoading = true
      apiCall({ url: 'tasks/'+this.theme.taskId+'/themes/' + this.theme.id, method: "GET"})
      .then((resp) => {
        for (var i=resp.length-1; i>=0; i--) {
          this.messages.push(resp[i])
        }
        this.isLoading = false
        this.$store.dispatch(NOTIFICATIONS_REQUEST)
        this.scrollToBottom()
      })
    },
    onMessageReceived(data) {
      if (this.theme.id != data.themeId) {
        return
      }
      this.messages.push(data)
      this.typing = this.typing.filter(t => t != parseInt(data.profileId))
      this.scrollToBottom()
      apiCall({ url: 'tasks/'+this.theme.taskId+'/themes/' + this.theme.id + '/read', method: "POST"})
      .then(() => {
        this.$store.dispatch(NOTIFICATIONS_REQUEST)
      })
    },
      onMessageUpdated(data) {
        console.log('message updated', data)
      if (this.theme.id != data.themeId) {
        return
      }
      const msgIndex = this.messages.findIndex(m => m.id == data.id)
      console.log(msgIndex)
      if (msgIndex != -1) {
        this.$set(this.messages, msgIndex, data)
      }
    },
    onMessageTypingAdded(data) {
      if (data.themeId != this.theme.id) {
        return
      }
      console.log('someone typing', data)
      let id = parseInt(data.profileId)
      if (this.typingHandlers[id]) {
        clearTimeout(this.typingHandlers[id])
      } else {
        this.typing.push(id)
      }
      this.typingHandlers[id] = setTimeout(() => {
        this.onMessageTypingRemoved(id)
      }, 5000)
    },
    onMessageTypingRemoved(id) {
      this.typing = this.typing.filter(t => t != id)
      this.typingHandlers[id] = null
    },
    onPaste(pasteEvent, callback) {
      if(!pasteEvent.clipboardData || !pasteEvent.clipboardData.items){
        if(typeof(callback) == "function"){
          callback(undefined);
        }
      }

      var items = pasteEvent.clipboardData.items;
      for (var i=0; i<items.length; i++) {
          if (items[i].type.indexOf("image") === -1) {
            continue;
          }
          var asd = 123
          asd += 123
          console.log(asd)
          console.log("IMAGE FOUND")
          var blob = items[i].getAsFile();
          this.$refs.upload.add(blob)
      }

    },
    handleEnter(e) {
      if (e.shiftKey) {
        return
      }
      e.stopPropagation()
      e.preventDefault()
      this.sendMessage()
    },
    handleKeyup() {
      if (this.meTyping) {
        return false
      } else {
        this.sendTyping()
      }
    },
    scrollToBottom() {
      this.$nextTick(() => {
        this.$refs.msgList.scrollTop = this.$refs.msgList.scrollHeight
      })
    },

    startUpload(file) {
      this.isUploading = true
      this.$refs.upload.update(file, {active: true})
    },
    // обновление статуса загружаемого файла
    inputFile(newFile, oldFile/*, prevent*/) {
      if (newFile && !oldFile) { // file added
        console.log(newFile)
        this.$nextTick(() => this.startUpload(newFile))
      }

      if (newFile && oldFile) {  // file updated
        if (newFile.success !== oldFile.success) {  // Uploaded successfully
          this.isUploading = this.composing.files.filter(f => !f.success).length > 0
        }
      }
    },
    sendTyping() {
      console.log('me typing')
      apiCall({ url: 'tasks/'+this.theme.taskId+'/themes/' + this.theme.id + '/typing', method: "POST"})
      clearTimeout(this.meTypingHandler)
      this.meTyping = true
      this.meTypingHandler = setTimeout(() => {
        this.meTyping = false
      }, 4000)
    },
    sendMessage() {
      if (this.isSending) {
        return
      }
      this.isSending = true
      var composed = Object.assign({}, this.composing)
      composed.files = []
      composed.fileIds = this.composing.files.filter(f => !!f.success).map(f => f.response.id)
      var url = 'tasks/'+this.theme.taskId+'/themes/' + this.theme.id
      if (composed.message_id) {
        url += '/edit/' + composed.message_id
      } else {
        url += '/send'
      }
      apiCall({ url: url, method: "POST", data: composed})
      .then(() => {
        this.composing = {
          message_id: null,
          text: "",
          files: [],
          taskId: this.task.id,
          themeId: this.theme.id,
        }
        this.isSending = false
      }).catch(() => {
        this.isSending = false
      });
    },
    onStartEditMessage(message) {
      if (this.composing.text && !confirm("Редактирование сообщение сбросит введенный текст. Продолжить?")) {
        return
      }
      this.composing.text = message.text
      this.composing.message_id = message.id
      console.log(this.$refs.textInput.$el)
      this.$refs.textInput.$el.focus()
    },
    cancelMessageEdit() {
      this.composing.text = ""
      this.composing.message_id = null
    }
  }
}
</script>

<style scoped>
.messages-block {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.header {
  background-color: #509E2F;
  color: #FFF;
  box-sizing: border-box;
  font-size: 1.39em;
  font-weight: 700;
}

.messages {
  flex: 1 1 auto;
  overflow: auto;
  padding: .5em;
  display: flex;
  flex-direction: column;
}
.messages.customer {
  background-color: #ffe2c0;
}

.compose {
  background-color: #EEE;
  padding: .5em;
  align-items: flex-start;
}
.compose > .btn {
  border: none;
  border-radius: none;
  box-shadow: none;
  background-color: transparent;
  opacity: .6;
}
.compose > .btn i {
  font-size: 1.2rem;
}
.compose > .btn:hover {
  opacity: 1;
}

.compose .files {
  max-height: 10rem;
  overflow: auto;
  overflow: overlay;
}

.typing {
  font-size: .85em;
  color: #777;
  padding: .2em;
}

</style>